import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Keep exactly one container mounted while forms switch to receipts or close.
// Multiple default-id containers compete for the same toast store and timers.
export default function WorkspaceNotifications() {
  return <ToastContainer position="top-right" autoClose={3000} closeOnClick pauseOnFocusLoss pauseOnHover />;
}
